import React, { useState } from "react";
import adminService from "../services/adminService";

const EmailUnlockForm = ({ closeModal }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await adminService.unlockUser(email);
      closeModal();
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-4">
        <label htmlFor="email" className="block text-sm font-bold mb-2">
          Email
        </label>
        <input
          type="text"
          id="email"
          className="w-full px-3 py-2 border rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
      <div className="flex justify-end">
        <button
          type="button"
          className="mr-2 px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Unlock
        </button>
      </div>
    </form>
  );
};

export default EmailUnlockForm;
